import {
  UPDATE_VOLCANO_LOCATION_REQUEST,
  CREATE_VOLCANO_LOCATION_REQUEST,
  CLEAR_EDIT_VOLCANO_LOCATION,
  GET_EDIT_VOLCANO_LOCATION_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST,
  EDIT_VOLCANO_LOCATION_OPEN_CONFIRMATION,
  EDIT_VOLCANO_LOCATION_CANCEL_CONFIRMATION,
  GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST,
} from './volcanoLocationEditReducer';


export const getVolcano = ({ id, history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_REQUEST, id, history });
export const clearVolcano = () => ({ type: CLEAR_EDIT_VOLCANO_LOCATION });
export const createVolcano = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_VOLCANO_LOCATION_REQUEST, data, formModel, location, goBack, history,
});
export const updateVolcano = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_VOLCANO_LOCATION_REQUEST, data, id, formModel, location, goBack, history,
});


export const getCountries = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST, history });
export const getMorphologies = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST, history });
export const getStatuses = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST, history });
export const getEruptionTimes = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST, history });
export const getLocations = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST, history });
export const openEditConfirmation = ({ formData }) => ({ type: EDIT_VOLCANO_LOCATION_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_VOLCANO_LOCATION_CANCEL_CONFIRMATION });
export const getRegions = ({ history }) => ({ type: GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST, history });
